import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Mouse = ({
  height = 24,
  width = 25,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 25" {...props}>
    <path
      d="M8.0625 20.8818C6.86903 20.8818 5.72443 20.4077 4.88052 19.5638C4.03661 18.7199 3.5625 17.5753 3.5625 16.3818V11.8818C3.5625 10.6884 4.03661 9.54377 4.88052 8.69986C5.72443 7.85594 6.86903 7.38184 8.0625 7.38184V7.38184C9.25597 7.38184 10.4006 7.85594 11.2445 8.69986C12.0884 9.54377 12.5625 10.6884 12.5625 11.8818V16.3818C12.5625 17.5753 12.0884 18.7199 11.2445 19.5638C10.4006 20.4077 9.25597 20.8818 8.0625 20.8818Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5625 13.0068H12.5625"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.0625 13.0068V7.38184C8.0625 6.48673 8.41808 5.62829 9.05101 4.99535C9.68395 4.36242 10.5424 4.00684 11.4375 4.00684V4.00684C12.3326 4.00684 13.191 4.36242 13.824 4.99535C14.4569 5.62829 14.8125 6.48673 14.8125 7.38184V9.06934C14.8125 9.81526 15.1088 10.5306 15.6363 11.0581C16.1637 11.5855 16.8791 11.8818 17.625 11.8818C18.3709 11.8818 19.0863 11.5855 19.6137 11.0581C20.1412 10.5306 20.4375 9.81526 20.4375 9.06934V4.00684"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
